/**
 * SharePlatformCTA - Reusable "share this site" call-to-action
 * Themed with primary colors. Uses the Web Share API when available,
 * falling back to clipboard copy. Shows a brief in-card toast on success.
 */

import { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../ui/Button';

export default function SharePlatformCTA() {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    const url = window.location.origin;
    const text =
      '🚀 Discover amazing AI prompts on PromptShare! Find, save & share the best prompts for ChatGPT, Midjourney and more.';

    if (navigator.share) {
      try {
        await navigator.share({ title: 'PromptShare', text, url });
      } catch (_) {
        /* user cancelled — no action needed */
      }
    } else {
      await navigator.clipboard.writeText(`${text}\n${url}`);
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    }
  };

  return (
    <section className="bg-white border border-gray-200 rounded-2xl p-8 text-center relative">
      <div className="w-14 h-14 bg-primary-50 border border-primary-100 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl" aria-hidden="true">
        🌍
      </div>
      <h3 className="text-xl font-bold text-gray-900 mb-2">
        Love PromptShare? Spread the word!
      </h3>
      <p className="text-gray-500 mb-6 max-w-xl mx-auto text-sm">
        Help your friends discover powerful AI prompts. Share PromptShare with your community and grow together.
      </p>

      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Button onClick={handleShare} size="md" className="gap-2">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.367 2.684 3 3 0 00-5.367-2.684z"
            />
          </svg>
          Share PromptShare
        </Button>
        <Link to="/prompts">
          <Button variant="outline" size="md">
            Explore More Prompts
          </Button>
        </Link>
      </div>

      {/* Clipboard success toast */}
      {copied && (
        <div
          role="status"
          aria-live="polite"
          className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-gray-900 text-white text-sm px-4 py-2 rounded-full shadow-lg"
        >
          ✅ Link copied to clipboard!
        </div>
      )}
    </section>
  );
}
